module.exports = __webpack_public_path__ + "assets/img/17_960_big.15cfc505.jpg";